import { useLocation, useNavigate } from 'react-router-dom';

// useChildNav opens a child screen (a form, a list's items, a protocol edit)
// as a new history entry, and closes it by popping that entry when it was
// opened in-app, so Back never reopens a closed form. Opened directly
// (refresh, link, home shortcut) there's no parent entry to pop, so close
// replaces with the parent instead.
export const useChildNav = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  // replace: swap one child for a sibling (desktop Add ↔ Upload), keeping
  // whether the first one was opened from its parent.
  const open = (path, extraState, { replace = false } = {}) =>
    navigate(path, {
      replace,
      state: { ...extraState, fromParent: replace ? !!state?.fromParent : true },
    });

  const close = (parentPath) => {
    if (state?.fromParent) navigate(-1);
    else navigate(parentPath, { replace: true });
  };

  return { open, close };
};

export default useChildNav;
